import {useEffect, useState} from "react";
import httpService from "../../services/httpService";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import { FaRegCircleCheck } from "react-icons/fa6";
import { FaSpinner } from "react-icons/fa6";
import {Accordion, Modal} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoadingFade from "../LoadingFade";
import { useAudioPlayerStore } from "../../store/store";
import InsightItem from "./InsightItem";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import NewInsightItem from "./NewInsightItem";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/esm/Tooltip";
import {FaFolderPlus, FaHandSparkles, FaLightbulb, FaRegFile, FaRobot} from "react-icons/fa";
import { FaPlay, FaPause } from "react-icons/fa";
const EpisodeModalComponent = ({ episode }) => {
    const [epi, setEpi] = useState({});
    const [insights, setInsights] = useState([]);
    const [loading, setLoading] = useState(true);
    const [insightsLoading, setInsightsLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [activeKey, setActiveKey] = useState(0);
    const [useInProcessing, setUseInProcessing] = useState(true);
    const [showCustomInsight, setShowCustomInsight] = useState(false);
    const [showGenerateInsights, setShowGenerateInsights] = useState(false);
    const [showDescription, setShowDescription] = useState(false);
    const { setAudioUrl, setFrom, setFeaturedImage, setEpisodeId, seekTo, setPlay, setPause, isPlaying, currentTime, duration, episodeId: storeEpisodeId } = useAudioPlayerStore();

    useEffect(() => {
        setLoading(true);
        const payload = {}
        httpService.get("/dash/wizard/get-podcast-club-episode/"+episode.pivot.podcast_club_id+"/"+episode.pivot.podcast_episode_id)
            .then((res) => {
                setEpi({...res.data.episode})
                setInsights(res.data.insights)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            setLoading(false);
        });
    }, [episode]);

    // const handleSaveEpisode = async (episode) => {
    //     setSaving(true)
    //     try {
    //         const res = await httpService.post("dash/wizard/save-episode",episode);
    //         if(res.data.status === 'created'){
    //             setEpi({...epi, saved:true})
    //             onEpisodeSaved()
    //         }
    //     } catch (err) {
    //         setErrorMessage(err.message)
    //     } finally {
    //         setSaving(false)
    //     }
    // }

    const generateInsights = async () => {
        setInsightsLoading(true);
        httpService.get("/dash/wizard/podcast-club-episode-generate-insights/"+episode.pivot.podcast_club_id+"/"+episode.pivot.podcast_episode_id+"/"+(useInProcessing ? 1 : 0))
            .then((res) => {
                setInsights(res.data.insights ?? [])
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            setInsightsLoading(false);
        });
    }

    const getInsights = () => {
        httpService.get("/dash/wizard/podcast-club-episode-get-insights/"+episode.pivot.podcast_club_id+"/"+episode.pivot.podcast_episode_id)
            .then((res) => {
                setInsights(res.data.insights)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            setLoading(false);
        });
    }

    const fmt = (s) => {
        if (!s || isNaN(s)) return '0:00';
        const m = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return `${m}:${sec.toString().padStart(2, '0')}`;
    };

    const isThisEpisode = storeEpisodeId === episode.pivot.podcast_episode_id;

    const loadIntoPlayer = () => {
        setFrom(epi.title);
        setFeaturedImage(epi.featured_image ?? null);
        setEpisodeId(episode.pivot.podcast_episode_id ?? null);
        setAudioUrl(epi.audio_url);
        setPlay();
    };

    const handlePlayPause = () => {
        if (!isThisEpisode) {
            loadIntoPlayer();
        } else if (isPlaying) {
            setPause();
        } else {
            setPlay();
        }
    };

    const handleSeek = (e) => {
        seekTo(Number(e.target.value));
    };

    const closeItem = (idx) => {
        console.log('close item')
        if (activeKey === String(idx)) setActiveKey(null);
    };

    const handleUseInProcessingChange = (e) => {
        setUseInProcessing(e.target.checked)
    }

    return(
        <div>
            <LoadingFade loading={loading} stateKey={loading?'loading':'not-loading'}>
                <Row className={'mb-3'}>
                    <Col sm={10} className={'d-flex flex-column justify-content-center align-content-center'}>
                        <h5>{epi.title}</h5>
                    </Col>
                    <Col sm={2} className={'text-center'}>
                        {epi.featured_image &&
                            <Image
                                src={epi.featured_image}
                                alt={epi.title}
                                width={48}
                                height={48}
                                style={{ objectFit: "cover", borderRadius: 8 }}
                                loading="lazy"
                            />
                        }
                    </Col>
                </Row>
                {epi.audio_url && (
                    <Row className={'mb-2 align-items-center'}>
                        <Col sm={1} className={'text-start'}>
                            <small className="text-muted">{fmt(isThisEpisode ? currentTime : 0)}</small>
                        </Col>
                        <Col sm={8}>
                            <input
                                type="range"
                                className="form-range"
                                min={0}
                                max={isThisEpisode ? (duration || 0) : 0}
                                step={0.1}
                                value={isThisEpisode ? currentTime : 0}
                                onChange={handleSeek}
                                disabled={!isThisEpisode}
                            />
                        </Col>
                        <Col sm={3}>
                            <Button
                                variant="outline-success"
                                size="sm"
                                onClick={handlePlayPause}
                            >
                                {isThisEpisode && isPlaying ? <FaPause size={11} /> : <FaPlay size={11} />}
                            </Button>

                            &nbsp;
                            &nbsp;

                            {insights.length <= 3 && (
                                <>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>Add Insights (using AI)</Tooltip>}
                                    >
                                        <Button disabled={insightsLoading}
                                                onClick={() => { setShowCustomInsight(false); setShowDescription(false); setShowGenerateInsights(v => !v); }}
                                                className=""
                                                size={'sm'}
                                                variant="outline-secondary"
                                        >
                                            <FaRobot />
                                        </Button>
                                    </OverlayTrigger>
                                    &nbsp;
                                    &nbsp;
                                </>
                            )}
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>Create insight manually</Tooltip>}
                            >
                                <Button disabled={insightsLoading}
                                        onClick={() => { setShowGenerateInsights(false); setShowDescription(false); setShowCustomInsight(v => !v); }}
                                        className=""
                                        size={'sm'}
                                        variant="outline-success"
                                >
                                    <FaHandSparkles />
                                </Button>
                            </OverlayTrigger>
                            &nbsp;
                            &nbsp;
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>{showDescription ? 'Hide' : 'Show'} Episode Description</Tooltip>}
                            >
                                <Button
                                    onClick={() => { setShowGenerateInsights(false); setShowCustomInsight(false); setShowDescription(v => !v); }}
                                    aria-controls="episode-description-collapse"
                                    aria-expanded={showDescription}
                                    variant="outline-primary"
                                    className=""
                                    size="sm"
                                >
                                    <FaRegFile />
                                </Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                )}
                <Row className={'mb-3'}>
                    {insights.length <= 3 && (
                        <Col sm={12}>
                            <Collapse in={showGenerateInsights} className={''}>
                                <div className="w-100 my-2">
                                    <p>AI will analyse this episode's transcript and generate key takeaways automatically. You can review and edit anything it suggests before moving forward.</p>
                                    <Button disabled={insightsLoading} onClick={generateInsights} variant="success" className={'text-white'}>
                                        {insightsLoading ? <FaSpinner className={"loading_spinner"} /> : 'Generate insights'}
                                    </Button>
                                </div>
                            </Collapse>
                        </Col>
                    )}
                    <Col sm={12}>
                        <Collapse in={showCustomInsight} className={''}>
                            <div id="" className="w-100 my-2">
                                <NewInsightItem
                                    podcast_episode_id={episode.pivot.podcast_episode_id}
                                    podcast_club_id={episode.pivot.podcast_club_id}
                                    onClose={setShowCustomInsight}
                                    onInsightSaved={getInsights}
                                    onInsightClickedPlay={(seconds) => { loadIntoPlayer(); seekTo(seconds); }}/>
                            </div>
                        </Collapse>
                    </Col>
                </Row>
                {insights.length ?
                    <Row className={'mb-3'}>
                        <Col>
                            <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
                                {insights.map((insight, index) => (
                                    <Accordion.Item key={insight.id} eventKey={String(index)}>
                                        <Accordion.Header>{insight.title}</Accordion.Header>
                                        <Accordion.Body>
                                            <InsightItem onInsightDeleted={() => closeItem(index)} insight={insight} onInsightSaved={getInsights} audioUrl={epi.audio_url}/>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}

                            </Accordion>
                        </Col>
                    </Row>
                    :
                    ""
                }
                <Row>
                    <Col sm={12}>
                        <Collapse in={showDescription}>
                            <div id="episode-description-collapse">
                                <div dangerouslySetInnerHTML={{__html: epi.description}}></div>
                            </div>
                        </Collapse>
                    </Col>
                </Row>
            </LoadingFade>

            {/*{epi?.audio_url && showAudioControl && (*/}
            {/*    <div*/}
            {/*        className="audio-control-fixed"*/}
            {/*        style={{*/}
            {/*            animation: 'fadeIn 0.5s ease-in',*/}
            {/*            opacity: 1*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <Button*/}
            {/*            variant="primary"*/}
            {/*            className="rounded-circle"*/}
            {/*            onClick={togglePlayPause}*/}
            {/*            style={{ width: '50px', height: '50px' }}*/}
            {/*        >*/}
            {/*            {isPlaying ? <FaPause /> : <FaPlay />}*/}
            {/*        </Button>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    )
}

export default EpisodeModalComponent;